import {useState, useEffect} from 'react';
import { useIsMobile } from 'newHooks/useIsMobile';
import { useHistory } from 'react-router-dom'
import { decodeStorage, encodeStorage } from 'functions/storageBase64'
import { BASE_PATH, BASE_PATH_API, BASE_PATH_API_DEV, ROUTE_PAGOS_EXPRESS, STAGE_DIRNAME, SUB_DIRECTORY } from 'constants/general'
import useTokenNew from './useTokenNew';
import { privateApiGet } from 'functions/privateApi';

export function useConsultaSaldoPage(props = false){
    const { route = [] } = props
    const { isMobile } = useIsMobile();
    const { access_token, isValid } = useTokenNew({name: 'useConsultaSaldoPage'})
    const history = useHistory()
    const cardending = decodeStorage('cardending')
    const lastConsultData = decodeStorage('lastConsultData')
    const sears_numero_internet = decodeStorage('sears_numero_internet')
    const listCardsData = decodeStorage('listCardsData')
    const [ udCard, setUdCard ] = useState(false)
    const [ validateRoute, setValidateRoute ] = useState(false)
    const [ loading, setLoading ] = useState(false)
    const [ response, setResponse ] = useState(lastConsultData)
    const [ noInternet, setNoInternet ] = useState(sears_numero_internet)
    const seccionPortal = window.location.pathname.replace(`/${SUB_DIRECTORY}`, '') || '/'
    const pagoExpress = decodeStorage('pagoExpress')
    const routePagosExpress = ROUTE_PAGOS_EXPRESS

    // Lista de tarjetas asociadas al cliente sears
    const getListCards = async () => {
        let lsToken = decodeStorage('access_token')
        const endpoint = '/credito-sears/v1/internet/card/list'
        
        try{
            if(lsToken){
                const result = await privateApiGet(endpoint)
                
                if (result.statusCode === 200 && result.data) {
                    const data = result.data
                    const no_internet = data?.cards[0]?.no_internet
                    const card = data?.cards[0]?.card_ending
                    if (card && no_internet) {
                        const associatedCards = data?.cards
                        encodeStorage('associatedCards',associatedCards)
                        encodeStorage('sears_numero_internet',no_internet)
                        encodeStorage('cardending',card)
                        encodeStorage('cardendingPayment',card)
                        setUdCard(true)
                    }
                } else if (result.statusCode === 401) {
                    console.warn('Token expired, will retry with refresh...')
                } else {
                    console.error('Error fetching list of cards:', result.error)
                }
            }
        }
        catch (error) { console.error('Error fetching list of cards:', error); }
    }

    // Lista de tarjetas asociadas al cliente sears
    const getCardData = async () => {
        let lsToken = decodeStorage('access_token')
        const endpoint = `/credito-sears/v1/cards/${cardending}?NoInternet=${sears_numero_internet}`
        
        try{
            if(lsToken){
                const result = await privateApiGet(endpoint)
                
                if (result.statusCode === 200 && result.data) {
                    const responseData = {
                        'statusCode': result.statusCode,
                        'data': result.data,
                        'error': ''
                    }
                    setResponse(responseData)
                    encodeStorage('listCardsData',responseData)
                    encodeStorage('cardendingPayment',cardending)
                    setNoInternet(sears_numero_internet)
                    setUdCard(false)
                } else if (result.statusCode === 401) {
                    console.warn('Token expired, will retry with refresh...')
                } else { 
                    console.error('Error fetching card data:', result.error) 
                }
            }
        }
        catch (error) { console.error('Error fetching card data:', error); }
    }

     useEffect(()=>{
        if(isValid){ 
            if( route?.find(item => item === seccionPortal )){
                getListCards()
                setLoading(true)
                setTimeout(()=>{
                    setValidateRoute(true)
                }, 700)
            }
            else{
                setValidateRoute(true)
            }
        }
    },[isValid])

    useEffect(()=>{
        if(validateRoute){  
            if(route?.find(item => item === seccionPortal )){  
                if(sears_numero_internet && ( cardending && (cardending != "undefined" && cardending != "dW5kZWZpbmVk" ) ) ){
                    if(udCard){
                        setLoading(true)
                        getCardData()
                    }else{
                        // console.log(' no tuvo  udCard: ', udCard,' response: ',response)
                        if(!response){
                            setLoading(true)
                            getCardData()
                        }
                    }
                }else{
                    setLoading(true)
                    getListCards() 
                }
            }else{
                if(listCardsData){
                    setLoading(false)
                    setResponse(listCardsData)
                    setUdCard(false)
                }
            }
        }
    },[validateRoute, udCard])
    
    const [cardsService, setCardsService] = useState()
    const [errorCode, setErrorCode] = useState()
    useEffect(()=>{
        // console.log('useConsultaSaldoPage --- response: ',response)
        if(response){
            setLoading(false)
            if(response?.statusCode){
                if(response?.statusCode === 200){
                    let dataProduct = response?.data
                    dataProduct[0].noInternet = sears_numero_internet
    
                    setCardsService(dataProduct[0])
                }
                else if(response?.statusCode === 401){
                    let codeError = JSON.parse(response?.data)
                    // forceToken(true)
                    setErrorCode(codeError)
                }
                else if(response?.statusCode >= 400 && response?.statusCode <= 499){
                    let codeError = JSON.parse(response?.data)
                    setErrorCode(codeError)
                }
                else if(response?.statusCode >= 500 ){
                    setErrorCode(response?.statusCode)
                    // console.log('err 500: ',response?.statusCode)
                }
            }else{
                setUdCard(true)
            }
        }
    },[response])

    
    useEffect(()=>{
        if(cardsService && cardsService?.length === 0){
            history.push(`${BASE_PATH}${SUB_DIRECTORY}`)
        }
        else if( !sears_numero_internet || sears_numero_internet === "undefined" ){
            const ifRoute = routePagosExpress?.find(item => item === seccionPortal )
            if(( !sears_numero_internet || sears_numero_internet === "undefined" ) && (!pagoExpress || pagoExpress === "undefined" )){
                if( ifRoute ){
                    history.push(`${BASE_PATH}${SUB_DIRECTORY}`)
                }else{
                    if(( !sears_numero_internet || sears_numero_internet === "undefined" )){
                        history.push(`${BASE_PATH}${SUB_DIRECTORY}`)
                    }
                }
            }
        }
    },[cardsService])

    return{
        cardsService,
        setUdCard,
        noInternet,
        loading,
        errorCode,
        isMobile
    }
}